import React, { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import paths from "routes/paths";

export default function TaskProgressPingsPage() {
  const { taskId } = useParams();
  const location = useLocation();

  useEffect(() => {
    document.title = "Task Progress & Pings";
  }, []);

  if (!taskId) {
    return <Navigate to={paths.tasks} replace />;
  }

  return (
    <Navigate
      to={paths.taskDetails(taskId)}
      replace
      state={{ ...(location.state || {}), openDrawer: "progressPings" }}
    />
  );
}
